export const SET_MENU_DATA = "SET_MENU_DATA"
export const RESET_MENU_DATA = "RESET_MENU_DATA"
